<template>
  <nav class="level is-mobile lxm-stat">
    <template v-for="s in stats">
      <div class="level-item has-text-centered" @click="itemClicked(s.to)">
        <p class="lxm-stat__value">{{ s.value }}</p>
        <p class="lxm-stat__title">{{ s.title }}</p>
      </div>
    </template>
  </nav>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .level:not(:last-child)
    margin-bottom: spacing
  .lxm-stat__value
    color: brand-primary
    font-size: size
    line-height: 1
    margin-bottom: spacing-small
  .lxm-stat__title
    color: grey-darker
    font-size: size-small
    line-height: 1
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      stats: Array
    },
    methods: {
      itemClicked (to) {
        if (to) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(to)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmStat.vue?774baa2e